import React, { useEffect, useContext } from "react";
import Home from "./pages/Home";
import Footer from "./components/Footer/Footer";
import NavBar from "./components/Navbar/Navbar";
import Login from "./components/Auth/Auth";
import { useAuthContext } from "./Hooks/useAuthContext";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./index.css";
import BreakingNews from "./components/BreakingNews/BreakingNews";
import Calendars from "./components/Calendars/Calendars";

import { SearchTickerContext } from "./Context/SearchTickerContext";
import { useLogout } from "./Hooks/useLogout";
import PostSingleView from "./components/Posts/PostSingleView";
import BreakingNewsSingleView from "./components/BreakingNews/BreakingNewsSingleView";
import SmartTradingHub from "./components/PostContainer/SmartTradingHub";
import Banned from "./pages/Banned";
import OnlineClass from "./components/Posts/OnlineClass";
import MarketTape from "./components/MarketTape/MarketTape";
import { PodcastProvider } from "./podcast/PlayerContext";
import PodcastLibrary from "./podcast/PodcastLibrary";
import PodcastNow from "./podcast/PodcastNow";
import MiniPlayer from "./podcast/MiniPlayer";
function App() {
  const { user } = useAuthContext();
  const { setValue, setSearchResults } = useContext(SearchTickerContext);

  const handleClear = () => {
    setValue("");
    setSearchResults([]);
    // window.location.reload();
  };

  const { logout } = useLogout();
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      logout();
    }, 4 * 60 * 60 * 1000); // Logout after 1 hours
    return () => clearTimeout(timeoutId); // Clean up the timeout on unmount
  }, [logout]);

  return (
    <div className="App" onDoubleClick={handleClear}>
      <BrowserRouter>
        <PodcastProvider>
        <MarketTape />
        <NavBar />
        <div className="Home-Page">
          <Routes>
            {user && user.user.role === 7 ? (
              <Route path="*" element={<Banned />} />
            ) : (
              <>
                <Route exact path="/" element={<Home />} />
                <Route path="/hub" element={<SmartTradingHub />} />
                <Route path="/chat" element={<Navigate to="/" replace />} />
                <Route path="/class" element={<OnlineClass />} />
                <Route path="/podcast" element={<PodcastLibrary />} />
                <Route path="/podcast/now" element={<PodcastNow />} />
                <Route path="/watchlist" element={<Navigate to="/" replace />} />
                <Route path="/earning" element={<Navigate to="/" replace />} />
                <Route path="/earning/:id" element={<Navigate to="/" replace />} />
                <Route path="/alerts" element={<Navigate to="/" replace />} />
                <Route path="/alert/:id" element={<Navigate to="/" replace />} />
                <Route path="/optionalerts" element={<Navigate to="/" replace />} />
                <Route path="/optionalert/:id" element={<Navigate to="/" replace />} />
                <Route path="/general" element={<Navigate to="/" replace />} />
                <Route path="/new/:id" element={<Navigate to="/" replace />} />
                <Route path="/future" element={<Navigate to="/" replace />} />
                <Route
                  path="/breaking"
                  element={user ? <BreakingNews /> : <Navigate to="/login" />}
                />
                <Route path="/insider" element={<Navigate to="/" replace />} />
                <Route path="/market-index" element={<Navigate to="/" replace />} />
                <Route path="/calendar" element={<Calendars />} />
                <Route
                  path="/login"
                  element={!user ? <Login /> : <Navigate to="/" />}
                />
                <Route path="/p/:id" element={<PostSingleView />} />
                <Route
                  path="/breakingnew/:id"
                  element={<BreakingNewsSingleView />}
                />
                <Route
                  path="/user/:id"
                  element={<Navigate to="/" replace />}
                />
              </>
            )}
          </Routes>
        </div>
        <Footer />
        <MiniPlayer />
        </PodcastProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
